var cov_2qyzpunmfv = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Quick.tsx",
      hash = "23b2d650f71227b60d0b54c3b590378b126c5d01",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Quick.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 25
        },
        end: {
          line: 9,
          column: 35
        }
      },
      "1": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 62
        }
      },
      "2": {
        start: {
          line: 14,
          column: 21
        },
        end: {
          line: 14,
          column: 31
        }
      },
      "3": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 64
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 22,
          column: 5
        }
      },
      "5": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 112
        }
      },
      "6": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 12
        }
      },
      "7": {
        start: {
          line: 23,
          column: 25
        },
        end: {
          line: 23,
          column: 35
        }
      },
      "8": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 33
        }
      },
      "9": {
        start: {
          line: 24,
          column: 18
        },
        end: {
          line: 24,
          column: 33
        }
      },
      "10": {
        start: {
          line: 28,
          column: 42
        },
        end: {
          line: 28,
          column: 52
        }
      },
      "11": {
        start: {
          line: 29,
          column: 25
        },
        end: {
          line: 29,
          column: 69
        }
      },
      "12": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 40
        }
      },
      "13": {
        start: {
          line: 30,
          column: 17
        },
        end: {
          line: 30,
          column: 40
        }
      },
      "14": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 46,
          column: 5
        }
      },
      "15": {
        start: {
          line: 34,
          column: 10
        },
        end: {
          line: 43,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        },
        loc: {
          start: {
            line: 8,
            column: 15
          },
          end: {
            line: 11,
            column: 3
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 3
          }
        },
        loc: {
          start: {
            line: 13,
            column: 36
          },
          end: {
            line: 16,
            column: 3
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 72
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 18
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 11
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 27
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 33,
            column: 20
          },
          end: {
            line: 33,
            column: 21
          }
        },
        loc: {
          start: {
            line: 34,
            column: 10
          },
          end: {
            line: 43,
            column: 16
          }
        },
        line: 34
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        }, {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        }],
        line: 19
      },
      "1": {
        loc: {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 24,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 24,
            column: 33
          }
        }, {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 24,
            column: 33
          }
        }],
        line: 24
      },
      "2": {
        loc: {
          start: {
            line: 29,
            column: 25
          },
          end: {
            line: 29,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 29,
            column: 50
          },
          end: {
            line: 29,
            column: 57
          }
        }, {
          start: {
            line: 29,
            column: 60
          },
          end: {
            line: 29,
            column: 69
          }
        }],
        line: 29
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 40
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 40
          }
        }],
        line: 30
      },
      "4": {
        loc: {
          start: {
            line: 30,
            column: 24
          },
          end: {
            line: 30,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 24
          },
          end: {
            line: 30,
            column: 32
          }
        }, {
          start: {
            line: 30,
            column: 36
          },
          end: {
            line: 30,
            column: 40
          }
        }],
        line: 30
      },
      "5": {
        loc: {
          start: {
            line: 38,
            column: 14
          },
          end: {
            line: 38,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 14
          },
          end: {
            line: 38,
            column: 53
          }
        }, {
          start: {
            line: 38,
            column: 57
          },
          end: {
            line: 38,
            column: 83
          }
        }],
        line: 38
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Quick.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import utils from './utils';
import { datepickerClass } from './styles';
import { getLocale } from '../locale';

var Quick =
/*#__PURE__*/
function (_ref) {
  _inherits(Quick, _ref);

  var _super = _createSuper2(Quick);

  function Quick() {
    _classCallCheck(this, Quick);

    return _super.apply(this, arguments);
  }

  _createClass(Quick, [{
    key: "getOptions",
    value: function getOptions() {
      cov_2qyzpunmfv.f[0]++;

      var _ref2 = (cov_2qyzpunmfv.s[0]++, this.props),
          timeZone = _ref2.timeZone;

      cov_2qyzpunmfv.s[1]++;
      return {
        timeZone: timeZone,
        startOfWeek: getLocale('startOfWeek')
      };
    }
  }, {
    key: "compareDate",
    value: function compareDate(a, b) {
      cov_2qyzpunmfv.f[1]++;

      var _ref3 = (cov_2qyzpunmfv.s[2]++, this.props),
          type = _ref3.type;

      cov_2qyzpunmfv.s[3]++;
      return utils.compareDateArray(a, b, type, this.getOptions());
    }
  }, {
    key: "handleQuick",
    value: function handleQuick(quick) {
      cov_2qyzpunmfv.f[2]++;
      cov_2qyzpunmfv.s[4]++;

      if (quick.invalid) {
        cov_2qyzpunmfv.b[0][0]++;
        cov_2qyzpunmfv.s[5]++;
        console.error("the date you provider for ".concat(quick.name, " is invalid, please check the date in quickSelect!"));
        cov_2qyzpunmfv.s[6]++;
        return;
      } else {
        cov_2qyzpunmfv.b[0][1]++;
      }

      var _ref4 = (cov_2qyzpunmfv.s[7]++, this.props),
          onChange = _ref4.onChange;

      cov_2qyzpunmfv.s[8]++;

      if (onChange) {
        cov_2qyzpunmfv.b[1][0]++;
        cov_2qyzpunmfv.s[9]++;
        onChange(quick);
      } else {
        cov_2qyzpunmfv.b[1][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      cov_2qyzpunmfv.f[3]++;

      var _ref5 = (cov_2qyzpunmfv.s[10]++, this.props),
          quicks = _ref5.quicks,
          current = _ref5.current,
          children = _ref5.children;

      var currentArray = (cov_2qyzpunmfv.s[11]++, Array.isArray(current) ? (cov_2qyzpunmfv.b[2][0]++, current) : (cov_2qyzpunmfv.b[2][1]++, [current]));
      cov_2qyzpunmfv.s[12]++;

      if (!quicks) {
        cov_2qyzpunmfv.b[3][0]++;
        cov_2qyzpunmfv.s[13]++;
        return (cov_2qyzpunmfv.b[4][0]++, children) || (cov_2qyzpunmfv.b[4][1]++, null);
      } else {
        cov_2qyzpunmfv.b[3][1]++;
      }

      cov_2qyzpunmfv.s[14]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('quick-select'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 32,
            columnNumber: 7
          }
        }, quicks.map(function (q) {
          cov_2qyzpunmfv.f[4]++;
          cov_2qyzpunmfv.s[15]++;
          return (
            /*#__PURE__*/
            React.createElement("div", {
              onClick: _this.handleQuick.bind(_this, q),
              className: datepickerClass('quick-select-item', (cov_2qyzpunmfv.b[5][0]++, _this.compareDate(q.value, currentArray)) && (cov_2qyzpunmfv.b[5][1]++, 'quick-select-item-active')),
              key: q.name,
              __self: _this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 34,
                columnNumber: 11
              }
            }, q.name)
          );
        }))
      );
    }
  }]);

  return Quick;
}((React.Component));

export { Quick as default };